export const initialStates = {
    user: [],
    credentials:[],
    connectAccountId:""
  };
  
